import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "AvatarComment",
  "use": "AvatarComment-usage",
  "viewBox": "0 0 83 72",
  "content": "<symbol viewBox=\"0 0 83 72\" xmlns=\"http://www.w3.org/2000/svg\" id=\"AvatarComment\"><path d=\"M19.276 14.835C25.672 6.478 35.75 1.087 47.087 1.087c19.33 0 35 15.67 35 35s-15.67 35-35 35c-11.68 0-22.023-5.72-28.381-14.514L.5 36.5l18.776-21.665z\" fill=\"#FFF\" stroke=\"#191919\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol